module.exports = __webpack_public_path__ + "f85230f0c6cb70662a87b3aca6d20415.png";